export const Scroll = {
  global: {
    body: document.querySelector('body'),
    header: document.querySelector(".c-header_inner-container"),
    headerContainer: document.getElementById("header"),
    progressBar: document.querySelector("#scrollIndicator"),
    switchMarkerLight: document.querySelector('#switchMarkerLight'),
    switchMarkerDark: document.querySelector('#switchMarkerDark'),
  },
  init() {
    this.setCurrentPosition();
    this.listener();
    this.scrollEventThrottle((scrollPos, previousScrollPos) => {
      if (window.innerWidth <= 767) {
        if (previousScrollPos > scrollPos) {
          Scroll.global.header.classList.remove("hidden");
          Scroll.global.headerContainer.classList.remove("hidden");
        } else {
          Scroll.global.header.classList.add('hidden');
          Scroll.global.headerContainer.classList.add('hidden');
        }
      }
    });
  },
  isInViewport(elem) {
    let bounding = elem.getBoundingClientRect();
    return (
      bounding.top
    );
  },
  scrollEventThrottle(fn) {
    let last_known_scroll_position = 0;
    let ticking = false;
    // Hide header on scroll on a news page
    window.addEventListener("scroll", function () {
      if (Scroll.global.body.classList.contains('single-news')) {
        let previous_known_scroll_position = last_known_scroll_position;
        last_known_scroll_position = window.scrollY;
        if (!ticking) {
          window.requestAnimationFrame(function () {
            fn(last_known_scroll_position, previous_known_scroll_position);
            ticking = false;
          });
          ticking = true;
        }
      }
    });
  },
  listener() {
    let url = window.location.href;
    let exp = url.split(/^(([^:\/?#]+):)?(\/\/([^\/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?/);
    let scrollPos = 0;

    let limits = {
      up: 800,
      down: -600
    }

    document.addEventListener('scroll', () => {
      const pixelScrolled = window.scrollY;
      const viewportHeight = window.innerHeight;
      const totalHeightScrollable = Scroll.global.body.scrollHeight;

      // convert pixels to percentage
      const pixelsToPercentage =
        ((pixelScrolled / (totalHeightScrollable - viewportHeight)) * 100);

      // Make header sticky
      if (pixelScrolled > 20) {
        Scroll.global.header.classList.add('stickied')
      } else if (Scroll.global.header.classList.contains("stickied")) {
        Scroll.global.header.classList.remove("stickied")
      }

      // Activate/Deactivate dark mode on scroll for Homepage only
      if (exp[5] == '/' && exp[7] == undefined) {

        if (window.innerWidth <= 767) {
          limits.down = -760;
        } else {
          limits.down = -600;
        }

        if (this.isInViewport(Scroll.global.switchMarkerLight) <= limits.up && this.isInViewport(Scroll.global.switchMarkerLight) >= limits.down) {
          document.documentElement.setAttribute('data-theme', 'light');
        } else {
          document.documentElement.setAttribute('data-theme', 'dark');
        }
      }

      // Progress bar
      Scroll.global.progressBar.style.height = "calc(" + Math.round(pixelsToPercentage) + "%)";

      // saves the new position for iteration.
      scrollPos = (document.body.getBoundingClientRect()).top;
    })
  },
  setCurrentPosition() {
    const body = document.querySelector("body");
    const progressBar = document.querySelector("#scrollIndicator");
    const pixelScrolled = window.scrollY;
    const viewportHeight = window.innerHeight;
    const totalHeightScrollable = body.scrollHeight;

    // convert pixels to percentage
    const pixelsToPercentage =
      ((pixelScrolled / (totalHeightScrollable - viewportHeight)) * 100);

    progressBar.style.height = "calc(" + Math.round(pixelsToPercentage) + "%)";
  }
}


// WEBPACK FOOTER //
// ./src/scripts/components/Scroll.js